<template>
    <div class="sidebar sidebar-dark sidebar-main sidebar-expand-md"  v-show="currentRoute.path !== '/login'">

        <!-- Sidebar mobile toggler -->
        <div class="sidebar-mobile-toggler text-center">
            <a href="#" class="sidebar-mobile-main-toggle">
                <i class="icon-arrow-left8"></i>
            </a>
            Navigation
            <a href="#" class="sidebar-mobile-expand">
                <i class="icon-screen-full"></i>
                <i class="icon-screen-normal"></i>
            </a>
        </div>
        <!-- /sidebar mobile toggler -->


        <!-- Sidebar content -->
        <div class="sidebar-content">

            <!-- User menu -->
            <div class="sidebar-user">
            </div>
            <!-- /user menu -->


            <!-- Main navigation -->
            <div class="card card-sidebar-mobile">
                <ul class="nav nav-sidebar" data-nav-type="accordion">

                    <!-- Main Menu -->
                    <li class="nav-item-header"><div class="text-uppercase font-size-xs line-height-xs">Main</div> <i class="icon-menu" title="Main"></i></li>
                    <template v-for="(route,index) in routeList">
                        <li class="nav-item" v-show="!route.hide && menuCheck(route)"  :key="'main'+index"  :class="subMenuClass(route.child)">
                            <router-link :to="route.path" v-if="route.icon && route.path !== '#'" :class="activeClass(route.path)">
                                <i :class="route.icon"></i> <span>{{route.text}}</span>
                            </router-link>
                            <a href="javascript:void(0)" v-if="route.icon && route.path === '#'" :class="activeClass(route.path)">
                                <i :class="route.icon"></i> <span>{{route.text}}</span>
                            </a>
                            <ul class="nav nav-group-sub" v-if="subMenuClass(route.child)">
                                <template v-for="(child,childIdx) in route.child">
                                    <li class="nav-item"  :key="'sub/'+index+'/'+childIdx" :class="subMenuHideClass(child)" v-show="menuCheck(child)">
                                        <router-link :to="child.path" :class="activeClass(child.path)">
                                            <i class="icon-arrow-right22"></i> {{child.text}}
                                        </router-link>
                                    </li>
                                </template>
                            </ul>
                        </li>
                    </template>
                    <!-- /main -->
                    <!-- /page kits -->

                </ul>
            </div>
            <!-- /main navigation -->

        </div>
        <!-- /sidebar content -->

    </div>
</template>

<script>
    import {mapGetters} from "vuex";

    export default {
        name: "layout-sidebar",
        data() {
            return {
                message: '',
                parameters: [],
            }
        },
        computed: {
            routeList: function() {
                return this.$router.options.list
            },
            userRole: function() {
                let user = this.getUser()
                return user?user.data.usrRole:''
            }
        },
        mounted() {
            this.navInit()
        },
        methods: {
            ...mapGetters({
                getUser: 'auth/getUser'
            }),
            menuCheck:function(route) {
                return this.userRole?(this.userRole.includes(route.role) || route.main):false
            },
            navInit:function() {
                $('.nav-link.active').closest('.nav-group-sub').slideDown(250)
                $('.nav-link.active').closest('.nav-item-submenu').addClass('nav-item-open')
            },
            subMenuHideClass:function(child) {
                 return child.hide? 'hide':''
            },
            activeClass:function(path) {
                return 'nav-link' +(this.currentRoute.path === path? ' active': '')
            },
            subMenuClass:function(child) {
                return (child && child.length > 0) ? 'nav-item-submenu' : 'nav-item-none-submenu';
            },
            navItemOpenClass: function() {
                return 'nav-item-open'
            }
        }
    }
</script>

<style scoped>
    .hide {
        display: none;
    }
</style>
